import { visit } from '../../../node_modules/unist-util-visit/lib/index.js';

function rehypeWrapTables(options = {
  className: "md-table-container"
}) {
  return (tree) => {
    visit(tree, "element", (node, index, parent) => {
      if (node.tagName === "table") {
        const wrapper = {
          type: "element",
          tagName: "div",
          properties: {
            className: [
              options.className
            ]
          },
          children: [
            node
          ]
        };
        if (parent && Array.isArray(parent.children) && index !== void 0) {
          parent.children.splice(index, 1, wrapper);
        }
      }
    });
  };
}

export { rehypeWrapTables as default };
//# sourceMappingURL=rehypeWrapTables.js.map
